import { getLocale, normalizeMessageBundleLocale, setLocale } from "@arcgis/core/intl";

export function decideAndSetLocale(portal?: __esri.Portal): string {
  // Query String
  const urlParams = new URLSearchParams(window?.location?.search);
  const queryStrLocale: string = urlParams.get('locale');
  // User Profile
  const userLocale: string = portal?.get("user.culture");
  // Browser
  const browserLocale: string = window?.navigator?.language;
  // Current Esri set Locale
  const locale: string = getLocale();

  /* Order of precedence for locale: 
   *       1st- query string
   *       2nd- locale set in user profile,
   *       3rd- browser (window.navigator.language)
   *       4th- locale currently set in JS api
   *       5th- all else fails, fallback to "en"
  **/ 
  const appLocale: string = queryStrLocale ?? userLocale ?? browserLocale ?? locale ?? "en";
  const normalizedLocale: string = normalizeMessageBundleLocale(appLocale as any);
  const finalLocale: string = normalizedLocale == null ? "en" : normalizedLocale; // Default locale is en
  setLocale(finalLocale);
  return finalLocale;
}


export function decideAndSetDir(appLocale: string): string {
  const dir = getLanguageDirection(appLocale);
  document.querySelector("html").setAttribute("dir", dir);
  return dir;
}


function getLanguageDirection(locale: string, rtlLocales: string[] = ["ar", "he"]): string {
  const isRTL = rtlLocales.some(language => {
    return locale.indexOf(language) !== -1;
  });
  return isRTL ? "rtl" : "ltr";
}